package com.parmartechnologies.ui.component.image

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import com.github.panpf.sketch.AsyncImage

@Composable
fun AsyncImageView(url: String, onFail: (() -> Unit) = {}) {
    Box (modifier = Modifier.fillMaxSize()){
        AsyncImage(
            uri = url,
            contentDescription = "photo",
            contentScale = ContentScale.FillBounds,
            modifier = Modifier.fillMaxSize()
        )
    }
}